import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '../../../misc/util/index';
import * as ɵngcc2 from '@angular/common';

var _c0 = ["templateSibling"];
function SuiMultiSelectLabel_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.formatter(ctx_r1.value), ɵngcc0.ɵɵsanitizeHtml);
} }
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input, HostBinding, HostListener, EventEmitter, ViewContainerRef, ViewChild, Renderer2, ElementRef, Output, ChangeDetectorRef, TemplateRef } from "@angular/core";
import { SuiTransition, TransitionController, Transition, TransitionDirection } from "../../transition/index";
import { HandledEvent, SuiComponentFactory } from "../../../misc/util/index";
// See https://github.com/Microsoft/TypeScript/issues/13449.
var templateRef = TemplateRef;
var SuiMultiSelectLabel = /** @class */ (function (_super) {
    __extends(SuiMultiSelectLabel, _super);
    function SuiMultiSelectLabel(renderer, element, changeDetector, componentFactory) {
        var _this = _super.call(this, renderer, element, changeDetector) || this;
        _this.componentFactory = componentFactory;
        // Initialise transition functionality.
        // Initialise transition functionality.
        _this._transitionController = new TransitionController(false, "inline-block");
        _this.setTransitionController(_this._transitionController);
        _this.onDeselected = new EventEmitter();
        _this._labelClasses = true;
        _this._transitionController.animate(new Transition("scale", 100, TransitionDirection.In));
        return _this;
    }
    Object.defineProperty(SuiMultiSelectLabel.prototype, "template", {
        get: function () {
            return this._template;
        },
        set: function (template) {
            this._template = template;
            if (this.template) {
                this.componentFactory.createView(this.templateSibling, this.template, {
                    $implicit: this.value,
                    query: this.query
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    SuiMultiSelectLabel.prototype.deselectOption = function (e) {
        var _this = this;
        e.eventHandled = true;
        this._transitionController.animate(new Transition("scale", 100, TransitionDirection.Out, function () {
            return _this.onDeselected.emit(_this.value);
        }));
    };
    SuiMultiSelectLabel.prototype.onClick = function (e) {
        e.eventHandled = true;
    };
    /** @nocollapse */
    SuiMultiSelectLabel.ctorParameters = function () { return [
        { type: Renderer2, },
        { type: ElementRef, },
        { type: ChangeDetectorRef, },
        { type: SuiComponentFactory, },
    ]; };
    SuiMultiSelectLabel.propDecorators = {
        "_labelClasses": [{ type: HostBinding, args: ["class.ui",] }, { type: HostBinding, args: ["class.label",] },],
        "value": [{ type: Input },],
        "query": [{ type: Input },],
        "onDeselected": [{ type: Output, args: ["deselected",] },],
        "formatter": [{ type: Input },],
        "template": [{ type: Input },],
        "templateSibling": [{ type: ViewChild, args: ["templateSibling", { read: ViewContainerRef },] },],
        "onClick": [{ type: HostListener, args: ["click", ["$event"],] },],
    };
SuiMultiSelectLabel.ɵfac = function SuiMultiSelectLabel_Factory(t) { return new (t || SuiMultiSelectLabel)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SuiComponentFactory)); };
SuiMultiSelectLabel.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuiMultiSelectLabel, selectors: [["sui-multi-select-label"]], viewQuery: function SuiMultiSelectLabel_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateSibling = _t.first);
    } }, hostVars: 4, hostBindings: function SuiMultiSelectLabel_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SuiMultiSelectLabel_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ui", ctx._labelClasses)("label", ctx._labelClasses);
    } }, inputs: { template: "template", value: "value", query: "query", formatter: "formatter" }, outputs: { onDeselected: "deselected" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [["templateSibling", ""], [3, "innerHTML", 4, "ngIf"], [1, "delete", "icon", 3, "click"], [3, "innerHTML"]], template: function SuiMultiSelectLabel_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", null, 0);
        ɵngcc0.ɵɵtemplate(2, SuiMultiSelectLabel_span_2_Template, 1, 1, "span", 1);
        ɵngcc0.ɵɵelementStart(3, "i", 2);
        ɵngcc0.ɵɵlistener("click", function SuiMultiSelectLabel_Template_i_click_3_listener($event) { return ctx.deselectOption($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.template);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiMultiSelectLabel, [{
        type: Component,
        args: [{
                selector: "sui-multi-select-label",
                template: "\n<span #templateSibling></span>\n<span *ngIf=\"!template\" [innerHTML]=\"formatter(value)\"></span>\n<i class=\"delete icon\" (click)=\"deselectOption($event)\"></i>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.SuiComponentFactory }]; }, { template: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ["click", ["$event"]]
        }], _labelClasses: [{
            type: HostBinding,
            args: ["class.ui"]
        }, {
            type: HostBinding,
            args: ["class.label"]
        }], value: [{
            type: Input
        }], query: [{
            type: Input
        }], onDeselected: [{
            type: Output,
            args: ["deselected"]
        }], formatter: [{
            type: Input
        }], templateSibling: [{
            type: ViewChild,
            args: ["templateSibling", { read: ViewContainerRef }]
        }] }); })();
    return SuiMultiSelectLabel;
}(SuiTransition));
export { SuiMultiSelectLabel };

